module.exports = __webpack_public_path__ + "static/media/admin.ee55f43b.png";